/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_AnnualInputs */

const en_common_annual = /** @type {(inputs: Common_AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annual`)
};

const de_common_annual = /** @type {(inputs: Common_AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jährlich`)
};

const fr_common_annual = /** @type {(inputs: Common_AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuel`)
};

const es_common_annual = /** @type {(inputs: Common_AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anual`)
};

const it_common_annual = /** @type {(inputs: Common_AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuale`)
};

const nl_common_annual = /** @type {(inputs: Common_AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaarlijks`)
};

const pl_common_annual = /** @type {(inputs: Common_AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rocznie`)
};

const fi_common_annual = /** @type {(inputs: Common_AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuosittain`)
};

const da_common_annual = /** @type {(inputs: Common_AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årligt`)
};

const sv_common_annual = /** @type {(inputs: Common_AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årligen`)
};

/**
* | output |
* | --- |
* | "Annual" |
*
* @param {Common_AnnualInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_annual = /** @type {((inputs?: Common_AnnualInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_AnnualInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_annual(inputs)
	if (locale === "fr") return fr_common_annual(inputs)
	if (locale === "es") return es_common_annual(inputs)
	if (locale === "it") return it_common_annual(inputs)
	if (locale === "nl") return nl_common_annual(inputs)
	if (locale === "pl") return pl_common_annual(inputs)
	if (locale === "fi") return fi_common_annual(inputs)
	if (locale === "da") return da_common_annual(inputs)
	if (locale === "sv") return sv_common_annual(inputs)
	return en_common_annual(inputs)
});